<h2 mat-dialog-title class="resumo-titulo">
  <mat-icon class="material-symbols-outlined">summarize</mat-icon>
  Resumo do inventário
</h2>

<mat-dialog-content class="resumo-content">
  @if (isLoading) {
    <div class="resumo-loading">
      <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else if (digitacao) {
    <div class="resumo-cabecalho">
      <div class="resumo-campo resumo-campo--wide">
        <small>Descrição</small>
        <span>{{ digitacao.descricao }}</span>
      </div>
      <div class="resumo-campo">
        <small>Responsável</small>
        <span>{{ digitacao.nomeUsuarioResponsavel || '—' }}</span>
      </div>
      <div class="resumo-campo resumo-campo--wide">
        <small>Locais de estoque</small>
        <span>{{ locaisEstoque }}</span>
      </div>
      <div class="resumo-campo">
        <small>Data do inventário</small>
        <span>{{ digitacao.dataInventario ? (digitacao.dataInventario | date: 'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="resumo-campo">
        <small>Data de conclusão</small>
        <span>{{ data.datetimeConclusao ? (data.datetimeConclusao | date: 'dd/MM/yyyy HH:mm') : '—' }}</span>
      </div>
      <div class="resumo-campo resumo-campo--wide">
        <small>Motivo do inventário</small>
        <span>{{ digitacao.motivo || '—' }}</span>
      </div>
      @if (digitacao.mensagemProcessamento) {
        <div class="resumo-campo resumo-campo--wide">
          <small>Mensagem</small>
          <span>{{ digitacao.mensagemProcessamento }}</span>
        </div>
      }
    </div>

    <div class="resumo-tabela-container">
      <table class="resumo-tabela">
        <thead>
          <tr>
            <th>Nome do produto</th>
            <th>Código (SKU)</th>
            <th>Unidade</th>
            <th>Categoria</th>
            <th class="text-end">Custo Médio</th>
            <th>Local de Estoque</th>
            <th class="text-end">Quant. inicial</th>
            <th class="text-end">Quant. inventariada</th>
            <th class="text-end">Ajuste no Estoque</th>
            <th class="resumo-erro-item">Mensagem</th>
          </tr>
        </thead>
        <tbody>
          @for (item of itens; track item.idInventarioItem) {
            <tr>
              <td>{{ item.nomeProduto }}</td>
              <td>{{ item.skuProduto || '—' }}</td>
              <td>{{ item.unidadeMedida || '—' }}</td>
              <td>{{ item.nomeCategoriaProduto || '—' }}</td>
              <td class="text-end">{{ formatarMoeda(item.custoMedio) }}</td>
              <td>{{ item.nomeLocalizacao }}</td>
              <td class="text-end">{{ formatarQtd(item.saldoSistema) }}</td>
              <td class="text-end">{{ formatarQtd(item.saldoContado) }}</td>
              <td class="text-end"
                [class.ajuste-positivo]="(item.ajusteEstoque ?? 0) > 0"
                [class.ajuste-negativo]="(item.ajusteEstoque ?? 0) < 0">
                {{ formatarQtd(item.ajusteEstoque) }}
              </td>
              <td class="resumo-erro-item">{{ item.erroProcessamentoItem || '—' }}</td>
            </tr>
          }
          @if (itens.length === 0) {
            <tr>
              <td [attr.colspan]="10" class="resumo-vazio">
                Nenhum item encontrado neste inventário.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
